'use client';

import React, { createContext, use } from 'react';
import Container from '@framework/di/Container';

type TProps = {
  container: Container,
  children: any,
};

// @ts-ignore TODO: FIN-32798 strictNullChecks
const DIContext = createContext<Container>(null);

/**
 * @deprecated - Please use @framework/di/getContainer instead
 */
export function useDIContext() {
  const context = use(DIContext);
  if (!context) {
    throw new Error('useDIContext must be used within the DIContextProvider');
  }
  return context;
}

function DIContextProvider({
  container,
  children,
}: TProps) {
  return (
    <DIContext.Provider value={ container }>
      { children }
    </DIContext.Provider>
  );
}

export default DIContextProvider;
